import React, { useEffect, useState } from 'react';
import UpdateEmailsForm from '../components/UpdateEmailsForm';
import { useGlobalState } from '../shared/state';
import { useNavigate } from 'react-router-dom';
import { Pages } from '../shared/pages';
import { UtagHelper } from '../utils/utagHelper';
import { AppFlow } from '@lib/web-shared';

const UpdateEmailsPage: React.FC = () => {
  const navigate = useNavigate();
  const [policyPaymentInfo] = useGlobalState('policyPaymentInfo');
  const [appFlow] = useGlobalState('appFlow');
  const [transactionId] = useGlobalState('transactionId');
  const [transactionProductPrefix] = useGlobalState('transactionProductPrefix');
  const [, setPrimaryEmail] = useGlobalState('primaryEmail');
  const [, setSecondaryEmail] = useGlobalState('secondaryEmail');
  const [clubCode] = useGlobalState('clubCode');
  const [clubTag] = useGlobalState('clubTag');
  const [policyMetaData] = useGlobalState('policyMetaData');
  const [tagging, setIsTagging] = useState(true);
  const { minimumDue, allowAutoPay, email } = policyPaymentInfo || {};
  const ins_min_due = minimumDue ? 'true' : 'false';

  useEffect(() => {
    const emailOnFile = !!email;
    const ins_policy = policyMetaData.prefix;
    const tags = { ...UtagHelper.loadCommonTags(appFlow) };
    const page = emailOnFile
      ? UtagHelper.getPages(appFlow).emailOnFilePage
      : UtagHelper.getPages(appFlow).noEmailOnFilePage;
    const ins_autopaycampaign = allowAutoPay ? 'autopay required' : 'autopay not required';
    UtagHelper.tag({
      ...tags,
      page,
      club: clubTag,
      ins_min_due,
      ins_autopaycampaign: appFlow === AppFlow.AUTOPAY ? undefined : ins_autopaycampaign,
      state: policyMetaData.state,
      ins_policy,
    });
    setIsTagging(false);
  }, []);

  const handleContinue = async (values: any) => {
    const { primaryEmail: primaryEmailEntryByUser, secondaryEmail } = values;
    setPrimaryEmail(primaryEmailEntryByUser);
    setSecondaryEmail(secondaryEmail);
    navigate(`${Pages.Confirmation}?transactionId=${transactionId}&pp=${transactionProductPrefix}`);
  };

  if (tagging) {
    return <></>;
  }

  return (
    <UpdateEmailsForm handleContinue={handleContinue} primaryEmail={policyPaymentInfo?.email} clubCode={clubCode} />
  );
};

export default UpdateEmailsPage;
